import {
    CLEAR_DEVICE_ERRORS,
    CREATE_NEW_DEVICE_DATA,
    DELETE_DEVICE_DATA,
    DEVICES_CLEAR_DATA,
    EDIT_DEVICE_DATA,
    KNOWN_DEVICES_FETCH_DATA,
    LOGOUT_USER,
    SAVE_DEVICES_TO_STORE,
    SUBMIT_DEVICE_DATA
} from "../../constant/reducerConstants";
import {DEFAULT_METADATA, DEVICE_STATUS, normalizeDevices, scrubDevice} from "../../util/DeviceUtils";
import db from '../persistence/db';

const initialState = {};

export function deviceReducer(state = initialState, action) {
    switch (action.type) {
        case KNOWN_DEVICES_FETCH_DATA:
            return {...state, ...normalizeDevices(action.data, state, {status: DEVICE_STATUS.known})};
        case DEVICES_CLEAR_DATA:
            return initialState;
        case CREATE_NEW_DEVICE_DATA:
            return {
                ...state,
                ...normalizeDevices([action.device], state, {status: DEVICE_STATUS.new})
            };
        case DELETE_DEVICE_DATA: {
            let output;
            if (state[action.id].metadata.status === DEVICE_STATUS.new) {
                let {[action.id]: removed, ...remaining} = state;
                output = remaining;
            } else if (state[action.id].metadata.status === DEVICE_STATUS.known) {
                output = {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        metadata: {
                            status: state[action.id].metadata.status,
                            edits: DEFAULT_METADATA.edits
                        }
                    }
                };
            }
            return output;
        }
        case CLEAR_DEVICE_ERRORS:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    metadata: {
                        ...state[action.id].metadata,
                        errorMap: undefined
                    }
                }
            };
        case EDIT_DEVICE_DATA: {
            let output = {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    metadata: {
                        ...state[action.id].metadata,
                        edits: {
                            ...state[action.id].metadata.edits,
                            ...action.edits
                        }
                    }
                }
            };
            /*
                It is discouraged to perform other actions in reducers like this but it is a simple solution to save the
                object after it has been merged with the current state. Could cause performance issues and may need to
                be revisited.
            */
            try {
                typeof action.callback === 'function' && action.callback(scrubDevice(output[action.id]));
            } catch (e) {
                // ignore
            }
            return output;
        }
        case SAVE_DEVICES_TO_STORE:
            return {
                ...state,
                ...normalizeDevices(action.devices, state)
            };
        case LOGOUT_USER:
            return initialState;
        /**
         * Submit device data will first normalize the devices that are returned from the server. These devices should
         * be the devices that encountered errors while processing. All other devices are checked for stored edits in
         * state and the database and subsequently scrubbed of this data, assuming the data has been updated on the server
         * side.
         */
        case SUBMIT_DEVICE_DATA:
            const errorDevices = normalizeDevices(action.data.errorDevices, state);
            const completedDevices = normalizeDevices(action.data.completedDevices, state);
            Object.keys(errorDevices).forEach(key => {
                state[key] = errorDevices[key];
            });
            Object.keys(completedDevices).forEach(key => {
                /*
                    It is discouraged to perform other actions in reducers like this but it is a simple solution to
                    delete the saved data after the device has been updated.
                */
                try {
                    db.deleteDevice(key);
                } catch (e) {
                    // ignore
                }
                delete state[key]
            });
            return {
                ...state
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/reducer/deviceReducer.js